"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
/* global window */
var delayedLocation = exports.delayedLocation = function delayedLocation(url, timeout) {
    return setTimeout(function () {
        window.location = url;
    }, timeout);
};

var actionThenRelocateWithTimeout = exports.actionThenRelocateWithTimeout = function actionThenRelocateWithTimeout(doAction, url) {
    var timeout = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 400;

    var relocateOnTimeout = delayedLocation(url, timeout);

    return doAction.then(function () {
        clearTimeout(relocateOnTimeout);
        window.location = url;
    });
};
//# sourceMappingURL=util.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/tracking/lib/cjs/util.js
 ** module id = 310
 ** module chunks = 0
 **/